<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="col xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12 p-2">
    <div class="shadow-2 surface-card border-round p-4 h-full">
        <div class="flex align-items-start mb-5">
            <div class="ml-3">
                <span class="block text-900 mb-1 text-xl font-medium"
                    >Sync Lists</span
                >
                <p class="text-600 mt-0 mb-0">
                    Click the Sync Lists Button to begin the process.
                </p>
            </div>
        </div>
        <div class="ml-3">
            <p>
                Sync Lists imports the QuickBooks Accounts, Employees, Service
                Items, Classes, Customer Jobs, and Company Preferences into the
                system. This process may take a few minutes to complete. The
                QuickBooks connection is linked to your QuickBooks company name,
                do NOT change it. If any change is required, even minor like "." or
                "," contact the eFAACT helpdesk for assistance.
            </p>

            <div [innerHtml]="AllStatuses | async | safe: 'html'"></div>
            <p>
                <p-button
                    label="Sync Lists"
                    icon="pi pi-refresh"
                    class="p-button-raised p-button-success"
                    (click)="syncLists()"
                    [disabled]="!(SyncEnabledSubject.asObservable() | async)"
                ></p-button>
            </p>
        </div>
    </div>
</div>
<!-- <p>
    Import Lists imports the QuickBooks Accounts, Employees, Service Items,
    Classes, Customer Jobs, and Company Preferences into the system. This
    process may take a few minutes to complete.
</p>
<p>Click the Sync Lists Button to begin the process.</p>
<div [innerHtml]="AllStatuses | async | safe: 'html'"></div>
<p>
<p-button
    label="Sync Lists"
    icon="pi pi-refresh"
    class="p-button-raised p-button-success"
    (click)="syncLists()"
    [disabled]="!(SyncEnabledSubject.asObservable() | async)"
></p-button>
</p> -->
